import { Injectable } from '@angular/core'
import { DatasetRepo, IgixRepo, PortletRepo, XcHelpOption } from '@gspwidget/util'
import { NzTreeNode, NzTreeNodeOptions } from 'ng-zorro-antd/core'
import { of } from 'rxjs/internal/observable/of'
import { map } from 'rxjs/operators'

@Injectable()
export class XcHelpPresetService {

  presets: {
    [presetName: string]: XcHelpOption<any>
  } = {
    csColumn: {
      xcTitle: 'éæ©æ ç®',
      xcParts: [{
        xcWidth: '30%',
        xcCols: [{ xcName: 'name', xcLabel: 'åºç¨'}],
        xcGetData: ({ http }) => {
          return http.get('/api/cms/cs/v1.0/application/all')
        },
        xcStructure: 'list',
      }, {
        xcWidth: '30%',
        xcCols: [{ xcName: 'name', xcLabel: 'åº'}],
        xcGetData: ({ http, parent }) => {
          return http.get(`/api/cms/cs/v1.0/columnstores/app?appId=${parent.id}`)
        },
        xcStructure: 'list',
      }, {
        xcTreeTitle: 'æ ç®',
        xcWidth: '40%',
        xcCols: ['code', 'name'],
        xcGetData: ({ http, parent }) => {
          return http
            .get(`/api/cms/cs/v1.0/columns/currentuser/store/permission/withtree?id=${parent.id}&permissionName=channel.manager`)
        },
        xcStructure: 'tree',
      }],
    },

    csEntity: {
      xcTitle: 'éæ©æ¨¡å',
      xcParts: [{
        xcWidth: '50%',
        xcCols: [{ xcName: 'name', xcLabel: 'åºç¨'}],
        xcGetData: ({ http }) => {
          return http.get('/api/cms/cs/v1.0/application/all')
        },
        xcStructure: 'list',
      }, {
        xcWidth: '50%',
        xcCols: [{ xcName: 'name', xcLabel: 'æ¨¡å'}],
        xcGetData: ({ http, parent }) => {
          return http.get(`/api/cms/cs/v1.0/entity/app?appId=${parent.id}`)
        },
        xcStructure: 'list',
      }]
    },

    eppNav: {
      xcTitle: 'éæ©é¨æ·å¯¼èªåç»',
      xcParts: [{
        xcCols: ['displayName'],
        xcGetData: ({ http }) => http.get('/api/cms/cs/v1.0/menu/all')
      }]
    },
    eppNavItem: {
      xcTitle: 'éæ©é¨æ·å¯¼èª',
      xcParts: [{
        xcCols: ['displayName'],
        xcGetData: ({ http }) => http.get('/api/cms/cs/v1.0/menu/all')
      }, {
        xcStructure: 'tree',
        xcGetData: ({ http, parent }) => http.get(`/api/cms/cs/v1.0/menuitem/tree/view/code/${parent.name}`)
      }]
    },

    eppDataset: {
      xcTitle: 'éæ©æ°æ®é',
      xcParts: [{
        xcCols: ['name', 'datasrcName', {
          xcName: 'lastModifyTime',
          xcDateFormat: 'yyyyå¹´MMæddæ¥',
        }],
        xcGetData: () => {
          return this.datasetRepo.getDatasets()
        }
      }]
    },

    eppPortlet: {
      xcTitle: 'éæ©é¨ä»¶',
      xcParts: [{
        xcStructure: 'tree',
        xcGetData: () => {
          return this.iGixRepo.getPortletCategoryTree().pipe(map(categoryTree => {
            return [{
                title: 'éç¨é¨ä»¶',
                id: 'COMMON_PORTLETS',
                key: 'COMMON_PORTLETS',
                isLeaf: true,
              } as NzTreeNodeOptions,
              ...categoryTree,
            ]
          }))
        }
      }, {
        xcCols: ['name'],
        xcGetData: ({ parent }) => {
          console.log(parent)
          const moduleId = parent.id === 'COMMON_PORTLETS' ? null : parent.id
          return this.portletRepo.getPortletsByModuleId(moduleId)
        }
      }]
    },

    rtfFuncsWithParentsChildren: {
      xcTitle: 'éæ©åè½',
      xcParts: [{
        xcStructure: 'multiTree',
        xcGetData: () => {
          return this.iGixRepo.getFuncTree1234()
        },
        xcMultiTreeOption: {
          result: 'withParentsChildren',
        }
      }]
    },

    /** ä»è¿åå¶å­ç»ç¹å³åè½èå */
    rtfFuncs4Only: {
      xcTitle: 'éæ©åè½',
      xcParts: [{
        xcStructure: 'multiTree',
        xcGetData: () => {
          return this.iGixRepo.getFuncTree1234()
        },
        xcMultiTreeOption: {
          processSelectedNodes: (nodes) => {
            const checkedFn4Nodes: NzTreeNode[] = []
            findFn4Recur(nodes, checkedFn4Nodes)
            return checkedFn4Nodes
          }
        }
      }]
    },

    curWidgetAction: {
      xcTitle: 'éæ©å¨ä½',
      xcParts: [{
        xcCols: [{xcName: 'title', xcLabel: 'å¨ä½'}],
        xcGetData: () => {
          // TODO: åé¨ä»¶é£è¾¹çæ¿è¿æ¥
          if (!window['widgetActionRegistry']) return
          const actionConfigs = window['widgetActionRegistry'][this.curWidgetNameGetter()]
          if (actionConfigs) {
            return of(Object.values(actionConfigs))
          }
          return of([])
        }
      }]
    }
  }

  curWidgetNameGetter: () => string

  constructor (
    public datasetRepo: DatasetRepo,
    public iGixRepo: IgixRepo,
    public portletRepo: PortletRepo,
  ) {}

  

}

// function findFn4Recur (originNodes: NzTreeNode[], targetList: NzTreeNode[]) {
//   if (!originNodes || originNodes.length === 0) return
//   if (originNodes[0].level === 3) {
//     targetList.push(...originNodes)
//   } else {
//     originNodes.forEach(node => {
//       if (node && node.children) findFn4Recur(node.children, targetList)
//     })
//   }
// }
function findFn4Recur (originNodes: NzTreeNode[], targetList: NzTreeNode[]) {
  if (!originNodes || originNodes.length === 0) return
  originNodes.forEach(node => {
    if (node.level === 3) {
      targetList.push(node)
    } else {
      if (node.children) findFn4Recur(node.children, targetList)
    }
  })
}
